/**
 * Correspondence Events Utility
 *
 * Centralizes browser event names and dispatch helpers for correspondence workflows.
 * Components like `NextStepsCard` listen to these to trigger UI updates immediately.
 */

export const CORRESPONDENCE_WORKFLOW_COMPLETED_EVENT =
  'correspondence-workflow-completed' as const;

export interface CorrespondenceWorkflowCompletedDetail {
  matterId: number;
  correspondenceIds?: number[];
  type?: 'notification' | 'collection-request' | 'follow-up' | 'reply' | string;
}

/**
 * Dispatch a standardized event indicating correspondence send completion.
 */
export function dispatchCorrespondenceWorkflowCompleted(
  detail: CorrespondenceWorkflowCompletedDetail
): void {
  if (typeof window === 'undefined') return;
  const event = new CustomEvent(CORRESPONDENCE_WORKFLOW_COMPLETED_EVENT, {
    detail
  });
  window.dispatchEvent(event);
}
